import React, { useEffect, useState } from "react";
import TopNav from "../TopNav/TopNav";
import { FiChevronDown } from "react-icons/fi";

// import ImagingHeader from "./ImagingHeader";
import ImagingNewHeader from "./ImagingNewHeader";
import ImagingFooter from "./ImagingFooter";

import BookForm from "../Plan-detail/BookForm";
import { razorKey } from "../../config/Axios";
import moment from "moment";
import { FaArrowLeft, FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Warning, Regards } from "../Plan-detail/NewPlanComponent";
import { BackToscreen } from "../New-Dashboard/Orders";

import {
  AddMore,
  FloatingButton,
  BackToscreenIcon,
  DesktopBack,
} from "../Cart/Cart";

import ImagingPackageInfo from "./ImagingPackageInfo";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEdit } from "react-icons/fa";
import {
  paymentUpadte,
  CreateBooking,
  SeletSlot,
  getCartDetails,
} from "../../Redux/Actions";

import Meta from "../Meta";
import { parse } from "qs";
import { json, response } from "express";
import { Scroll } from "../Scroll function/scroll";
import { SEND_PROFILE_DATA_ERROR } from "../../Redux/Constants";
import Axios from "../../config/Axios";
import Prefix from "../../config/ApiPrefix";

function Review(props) {
  useEffect(() => {
    Scroll();
  }, []);
  const [coupnDis, setCoupn] = useState(props.location.state ?? 0);
  const cartDetails = useSelector((state) => state.CartReducer);
  const SlotData = useSelector((state) => state.SelectedSlot);
  const Center = useSelector((state) => state.setImgCenterAddressReducer);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const currentcity = citySelected.citySelect;
  console.log(Center.id, "SLOT DATA");
  // console.log(
  //   "start time",
  //   SlotData.state.slot.start_time,
  //   "end time",
  //   SlotData.state.slot.end_time
  // );
  console.log("cart details", cartDetails);
  const { loading, cartDetails: cartdata } = cartDetails;
  const dispatch = useDispatch();
  //calling booking
  const CardInfo = ({ cartData }) => {
    <div className="box">
      {/* {console.log("this is cart data", cartData)} */}
      <div className="flexDirect paddng_2 borderBtm">
        {/* <h2 className="textblueBold" style={{width:"90%"}}>{cartData.name}</h2> */}
      </div>
      <div className="">
        <div style={{ marginTop: "1rem" }}>
          <span
            className="paddng_2"
            style={{ fontWeight: "600", color: "gray" }}
          >
            {/* {cartData?.parameter > 1 ? "Inclusions" : "Inclusion"} :{" "}
            {cartData?.parameter > 1
              ? `${cartData?.parameter} Tests`
              : `${cartData?.parameter} Test`} */}
          </span>
          <p className="paddng_2">55</p>
        </div>

        <div className="flexDirect">
          <div className="price_info">
            <span
              className="textpink"
              style={{ textDecoration: "line-through" }}
            >
              Rs.33/-
            </span>
            <span className="textblueBold">Rs.111/-</span>
            <span className="btn_neon">Get 11% OFF</span>
          </div>
          {/* {Review ? (
            <div className="price_info">
              <span className="plusMinus">
                <AiOutlineMinusCircle />
                45
                <AiFillPlusCircle />
              </span>
            </div>
          ) : null} */}
        </div>
      </div>
    </div>;
  };

  const getDate = useSelector((state) => state.SelectedSlot);
  console.log("GET DATE", SlotData);
  console.log("GET DATE", SlotData?.state?.slot?.id);

  // useEffect(()=>{
  //   const bookAdd = JSON.parse(localStorage.getItem("addressDetail"));
  // },[])

  const BookingApiPromise = () => {
    console.log("isilj promise");
    const datekey = JSON.parse(localStorage.getItem("user"));
    const patientDetails = JSON.parse(localStorage.getItem("patientDetail"));
    const patientAddress = JSON.parse(localStorage.getItem("addressDetail"));
    const center = JSON.parse(localStorage.getItem("hospAddr"));
    const coupnCode = JSON.parse(localStorage.getItem("coupnCode"));
    console.log();
    const body = {
      booking_date: moment(new Date()).format("YYYY-MM-DD"),
      collection_slot: getDate.state.slot.id,
      collection_date: getDate?.state?.date,
      customer_name: patientDetails && patientDetails?.name,
      customer_age: patientDetails && patientDetails?.year,
      customer_email: patientDetails && patientDetails?.email,
      customer_gender: patientDetails && patientDetails?.gender,
      customer_phonenumber: patientDetails && patientDetails?.mobile,
      customer_altphonenumber: patientDetails && patientDetails?.mobile,
      customer_whatsapppnumber: patientDetails && patientDetails?.mobile,
      // customer_areapincode: patientDetails && patientDetails?.area?.id,
      packages: productListArray,
      center: center?.center_address?.id,
      center_address: center?.id,
      coupon_applied: coupnCode.id ?? null,
      is_redcash_applied: localStorage.getItem("is_redcash_applied"),
    };
    if (localStorage.getItem("is_redcash_applied") == "true") {
      delete body["coupon_applied"];
    } else {
      delete body["is_redcash_applied"];
    }
    const config = {
      headers: {
        Authorization: `Token ${datekey.token}`,
      },
    };

    return new Promise((resolve, reject) => {
      Axios.post(`${Prefix.api}/booking/customer/create/imaging/`, body, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          alert(JSON.stringify(err.response.data.errors));
        });
    });
  };
  // console.log(razorKey,"<>");
  const handlePressEvent = () => {
    setDisableRazorpay(true);
    BookingApiPromise()
      .then((response) => {
        var options = {
          // key: razorKey,
          key: "rzp_live_sDovuuBgCu9dw3",
          // key : "rzp_test_kBEHIT9OH5OYyo",
          amount: parseInt(response?.amount?.receivable_amount) * 100,
          // amount: parseInt(response?.discounted_price?.final_total_price) * 100,
          currency: "INR",
          name: "Redcliffe Labs",
          description: `Credit Towards ${response?.customer_name}`,

          handler: function(response) {
            console.log(response, "hdskjd");
            const body = {
              paymentid: response?.razorpay_payment_id,
              bookingid: response?.pk,
            };
            const datekey = JSON.parse(localStorage.getItem("user"));
            dispatch(paymentUpadte(datekey?.token, body));
            setTimeout(() => {
              history.push("/confirmed");
              // localStorage.removeItem("customerDetails");
            }, 500);
          },
          prefill: {
            name: response?.customer_name,
            email: response?.customer_email,
            contact: response?.customer_phonenumber,
          },
          notes: {
            bookingid: response?.pk,
          },
          theme: {
            color: "#0a406b",
          },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();

        localStorage.setItem("bookingid", response?.pk);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const [customer, setCustomer] = useState("");
  const [showDetails, setShowDetails] = useState(true);
  //FETCHING CUSTOMER RESPONSE
  useEffect(() => {
    const customerData = JSON.parse(localStorage.getItem("customerDetails"));

    setCustomer(customerData);

  }, []);

  const history = useHistory();
  if (customer !== "") {
    var finalPrice = customer?.discounted_price.final_total_price;
    var totalPrice = customer?.discounted_price.total_price_package;
    var phleboCost = customer?.discounted_price.phlebo_cost;
    var coupnDiscount = customer?.discounted_price.counpon_discount;
    console.log("phlebo cost", phleboCost);
    var discountPrice = finalPrice - totalPrice;
  }

  useEffect(() => {
    let timeSlott = localStorage.getItem("timeSlotID");
    // console.log("?????", JSON.parse(timeSlot))
    let timeSlot = JSON.parse(timeSlott);
    let selDatee = localStorage.getItem("selDateDate");
    let selDate = JSON.parse(selDatee);
    console.log(">>>>>", selDate);
    
  }, []);

  // let packageListArray = localStorage.getItem("packageListArray");

  const PackageListAry = () => {
    let array = [];
    cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product.forEach((item) => {
        array.push(item.package.id);
      });
    return array;
  };

  const productListArray = PackageListAry();

  // for the pricing start

  var deliveryCharges = 0;

  const [details, setDetails] = useState([]);

  useEffect(() => {
    if (
      cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product
    ) {
      setDetails(cartDetails.cartDetails[0].product);
    }
  }, [cartDetails && cartDetails]);
  if (details !== "") {
    var sum = details.reduce((currentSum, nextObject) => {
      // Note that you need to coerce points_earned
      // to a Number or it will simply concatenate the strings
      return (currentSum += nextObject?.package?.package_center_address_prices
        ? nextObject?.package?.package_center_address_prices?.package_price
        : nextObject?.package?.package_price);

      // 0 is your initial value used by currentSum in
      // the first iteration
    }, 0);

    console.log("this is some", sum);
  }
  if (details !== "") {
    var offerSum = 0;
    let numOfTrue = 0;
    // console.log(details, "Lenght Detail obj")
    details.map((item) => {
      if (item?.package?.is_addon) {
        numOfTrue += 1;
      }
    });

    if (details.length == numOfTrue) {
      console.log("all are add on packages");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        currentOfferSum += nextObject?.package?.package_center_address_prices
          ? nextObject?.package?.package_center_address_prices?.offer_price
          : nextObject?.package?.offer_price;
        console.log(
          nextObject?.package?.package_center_address_prices
            ? nextObject?.package?.package_center_address_prices?.offer_price
            : nextObject?.package?.offer_price,
          "Now only offer price"
        );
        return currentOfferSum;
      }, 0);
    } else {
      // props.setAllAddonFalse()
      console.log("all are not add on");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        if (nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.addon_price;
          console.log(
            nextObject?.package?.addon_price,
            " Add on price package found"
          );
        } else if (!nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.package_center_address_prices
            ? nextObject?.package?.package_center_address_prices?.offer_price
            : nextObject?.package?.offer_price;
          console.log(
            nextObject?.package?.package_center_address_prices
              ? nextObject?.package?.package_center_address_prices?.offer_price
              : nextObject?.package?.offer_price,
            "Offer price/pack citywise package found"
          );
        }
        return currentOfferSum;
      }, 0);
    }

    // if (offerSum < 99) {
    //   deliveryCharges = 200;
    // }
  }
  if (details !== "") {
    var discountSum = sum - offerSum;
    var discountPercent = Math.ceil((discountSum / sum) * 100);
  }

  // for the pricing cart end ^^^^

  const handlePayLaterPromise = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    const patientDetails = JSON.parse(localStorage.getItem("patientDetail"));
    const patientAddress = JSON.parse(localStorage.getItem("addressDetail"));
    const center = JSON.parse(localStorage.getItem("hospAddr"));
    const coupnCode = JSON.parse(localStorage.getItem("coupnCode"));

    const body = {
      booking_date: moment(new Date()).format("YYYY-MM-DD"),
      collection_slot: getDate?.state?.slot?.id,
      collection_date: getDate?.state?.date,
      customer_name: patientDetails && patientDetails?.name,
      customer_age: patientDetails && patientDetails?.year,
      customer_email: patientDetails && patientDetails?.email,
      customer_gender: patientDetails && patientDetails?.gender,
      customer_phonenumber: patientDetails && patientDetails?.mobile,
      customer_altphonenumber: patientDetails && patientDetails?.mobile,
      customer_whatsapppnumber: patientDetails && patientDetails?.mobile,
      // customer_areapincode: patientDetails && patientDetails?.area?.id,
      packages: productListArray,
      center: center?.center_address?.id,
      center_address: center?.id,
      coupon_applied: coupnCode.id ?? null,
      is_redcash_applied: localStorage.getItem("is_redcash_applied"),
    };
    if (localStorage.getItem("is_redcash_applied") == "true") {
      delete body["coupon_applied"];
    } else {
      delete body["is_redcash_applied"];
    }
    const config = {
      headers: {
        Authorization: `Token ${datekey.token}`,
      },
    };

    return new Promise((resolve, reject) => {
      Axios.post(`${Prefix.api}/booking/customer/create/imaging/`, body, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          alert(JSON.stringify(err.response.data.errors));
        });
    });
  };
  const [disable, setDisable] = useState(false);
  const [disableRazorpay, setDisableRazorpay] = useState(false);
  
  const handlePayLater = () => {
    setDisable(true);
    handlePayLaterPromise()
      .then((response) => {
        console.log("PK ID RETURN THROUGH PROMISE", response?.pk);
        localStorage.setItem("bookingid", response?.pk);
        history.push("/confirmed");
      })
      .catch((error) => {
        console.log(error, "errorrrr In Book Now Pay Later");
        // history.push("/");
      });

    // dispatch(CreateBooking(body, datekey.token))
    // dispatch(SeletSlot(timeSlot, selDate.date))

    // history.push("/confirmed");
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user") ?? null);
    const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));
    var token = userFromLocal.token ?? null;
    dispatch(getCartDetails(token, currentcity, CenterAddress?.id));
  },[])

  return (
    <>
      <Meta>
        <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
      </Meta>
      {/* <TopNav isImagine={true} /> */}
      <ImagingNewHeader />

      {/* <BackToscreen title="  " /> */}
      <BackToscreenIcon title="Order Review" currpath="imagine/or" />
      <div className="review container reviewContainerMb">
        <DesktopBack title="Order Review" currpath="imagine/or" />
        {/* <div className="back_btn">
          <Link to="/userdashboard">  
            <FaArrowLeft />
            Order Review
          </Link>
        </div> */}

        <div className="cart_main">
          <div className="cart_leftSide  ">
            <div className="neonBox patientForm ReviewForm">
              {/* <span>Selected Slot</span>
              <span className="my_1">
                Redcliffe labs Diagnostics Pvt. Ltd. Noida Sector-62
              </span> */}
              <div className="editSlot d_flex justify_spaceBetween">
                <span className="textSecondary " style={{ fontWeight: "500" }}>
                  {getDate &&
                    getDate !== "" &&
                    moment(getDate.state?.date).format("Do MMM ")}{" "}
                  ,{" "}
                  {SlotData && SlotData !== ""
                    ? `${SlotData?.state?.slot.slot12_time.start_time} - ${SlotData?.state?.slot.slot12_time.end_time}`
                    : null}
                </span>
                <div
                  className="d_flex justify_spaceBetween flex_center click"
                  style={{ color: "grey" }}
                  onClick={history.goBack}
                >
                  {/* <Link to="/slot"  > */}
                  <FaRegEdit />
                  Edit Slot
                  {/* </Link> */}
                </div>
              </div>
            </div>

            {cartDetails &&
              cartDetails.cartDetails &&
              cartDetails.cartDetails[0] &&
              cartDetails.cartDetails[0].product.length > 0 &&
              cartDetails.cartDetails[0].product.map((values) => {
                return <ImagingPackageInfo key={values.id} cartData={values} />;
            })}

            {/* <div className="neonBox patientForm ReviewForm">
              <span>Sample PickUp Address</span>
              <span className="my_1">
                {bookAdd && bookAdd !== ""
                  ? bookAdd?.house_number
                  : null}

                <div className="orAddressEdit">
                  <span>
                    {`${
                      bookAdd && bookAdd !== "" ? bookAdd?.house_number : null
                    }, ${
                      bookAdd && bookAdd !== "" ? bookAdd?.street_name : null
                    }`} Address
                  </span>

                  <span className="editAddBtn">
                    <Link to="/address">
                      <FaRegEdit />
                      Edit Address
                    </Link>
                  </span>
                </div>
              </span>
              <div className="editSlot d_flex justify_spaceBetween">
                <span className="addressField">
                  {bookAdd && bookAdd !== ""
                    ? bookAdd?.street_name
                    : null}
                </span>
                <div className="d_flex justify_spaceBetween flex_end">
                  <FaRegEdit />
                  Edit Address
                </div>
              </div>
            </div>
            <AddMore /> */}

            <Warning desc="Physical visit to the centre required" />
            {/* <Regards /> */}
          </div>

          <div className="cart_RightSide">
            <div className="mobilePatientForm">
              <div>
                <div className="booking_Razordiv">
                  <div className="topRazor">
                    <p>
                      <span className="textblueBold offerprice">
                        ₹{details !== "" ? offerSum : offerPrice && offerPrice}
                      </span>
                      &nbsp;{" "}
                      <span className="sellingPrice">
                        ₹{details !== "" ? sum : Mrp && Mrp}
                      </span>
                    </p>
                    {/* <span className="btn_neon">Get {discountPercentage}% OFF</span> */}
                    <span className="btn_neon">
                      Get{" "}
                      {details !== ""
                        ? discountPercent
                        : discountPercentage && discountPercentage}
                      % OFF
                    </span>
                  </div>
                  <div className="borderBook" />
                  <div className={showDetails ? "toogleBook" : "height0"}>
                    {/* <div className="priceBreakParent">
                      <span>Home Collection Charges</span>
                      <div className="rightSidediv_booking">
                       
                        <span className="textSecondary">FREE</span>
                      </div>
                    </div>
                    <div className="borderBook" /> */}

                    <div className="priceBreakParent">
                      <span>Offer Price</span>
                      <div>
                        {/* <span>₹{packageDetails?.package_price}</span> */}
                        {/* <span> ₹ {details !== "" && sum}</span> */}₹
                        {details !== "" ? offerSum : offerPrice && offerPrice}
                      </div>
                    </div>

                    {/* <div className="priceBreakParent">
                      <span>Delivery Charges</span>
                      <div>
                        <span>₹{deliveryCharges}</span>
                      </div>
                    </div> */}

                    {/* <div className="priceBreakParent">
                      <span>Discount</span>
                      <div>
                        <span>₹ - {details !== "" && discountSum}</span>
                      </div>
                    </div> */}

                    {coupnDis > 0 ? (
                      <div className="priceBreakParent">
                        <span className="coupnSpan">
                          {localStorage.getItem("is_redcash_applied") == "true"
                            ? "Redcash"
                            : "Coupon"}{" "}
                          Applied
                        </span>
                        <div>
                          <span>-₹ {coupnDis}</span>
                        </div>
                      </div>
                    ) : null}
                    <div className="borderBook" />

                    <div
                      className="priceBreakParent"
                      style={{
                        fontWeight: " 700",
                        fontSize: "1.8rem",
                        color: "#0a406b",
                      }}
                    >
                      <span>Total Amount</span>
                      <div>
                        <span>
                          ₹{" "}
                          {details !== ""
                            ? offerSum + deliveryCharges - coupnDis
                            : finalPrice && finalPrice}
                        </span>
                      </div>
                    </div>
                  </div>

                  <span className="guidelines">
                    *inclusive of all the taxes, fees and subject to
                    availability
                  </span>
                  <div className="borderBook" />
                </div>

                <div className="booking_Razordiv">
                  <p className="textSecondary note">
                    YOU SAVED Rs. {details !== "" && discountSum + coupnDis} ON
                    THIS BOOKING!
                  </p>
                  <div className="payLaterBtn">
                    <button
                      disabled={disable ? "disabled" : ""}
                      style={
                        disable
                          ? { cursor: "not-allowed", pointerEvents: "none" }
                          : null
                      }
                      onClick={() => handlePayLater()}
                    >
                      Book Now & Pay Later
                    </button>
                  </div>
                  {/* <div className="coupnCODE">
          <input placeholder="Enter Coupon Code" />{" "}
          <span className="textpink"> Apply</span>
        </div> */}

                  {disableRazorpay ? <></> : <span
                    className="add_tocartt "
                    onClick={() => handlePressEvent()}
                  >
                    {/* {details !== "" && discountSum ? "PROCEED" : "ADD TO CART"}{" "} */}
                    PAY VIA RAZORPAY
                  </span>}

                  {/* MOBILE VIEW */}
                  <div className="floatWindow">
                    <span className="floatAmt">
                      Total Amount <br></br>₹{" "}
                      {details !== ""
                        ? offerSum + deliveryCharges - coupnDis
                        : finalPrice && finalPrice}
                    </span>
                    {disableRazorpay ? <></> :<span
                      className="add_tocart "
                      onClick={() => handlePressEvent()}
                    >
                      {/* {details !== "" && discountSum ? "PROCEED" : "ADD TO CART"}{" "} */}
                      PAY VIA RAZORPAY
                    </span>}
                  </div>
                </div>
              </div>
              {/* <BookForm empty={false} patientDetailF={patientFormn}/> */}
            </div>
          </div>
        </div>
      </div>

      {/* <ImagingFooter telNumber="898 898 0101" /> */}
    </>
  );
}

export default {
  component: Review,
};
